import { render, staticRenderFns } from "./PrivacyContentCN.vue?vue&type=template&id=29a15f72&scoped=true"
import script from "./PrivacyContentCN.vue?vue&type=script&lang=js"
export * from "./PrivacyContentCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a15f72",
  null
  
)

export default component.exports